import { render, staticRenderFns } from "./activeDetail.vue?vue&type=template&id=4e925595&scoped=true&"
import script from "./activeDetail.vue?vue&type=script&lang=js&"
export * from "./activeDetail.vue?vue&type=script&lang=js&"
import style0 from "./activeDetail.vue?vue&type=style&index=0&id=4e925595&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e925595",
  null
  
)

export default component.exports